import React, { useState, useCallback, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Rnd } from 'react-rnd';
import { Icon } from '@shakkerai/components';
import { setTempState, useTempState } from '@starflow/app/store';

const initialImagesWindowZIndexs = {
  images: 105,
  modelImages: 105,
};

export const ImageWindowWrapper = React.memo((props) => {
  const { label, type } = props;
  const [position, setPosition] = useState(null);
  const isModelImages = type === 'modelImages';
  const imagesWindowZIndexs = useTempState('imagesWindowZIndexs') || initialImagesWindowZIndexs;
  const zIndex = imagesWindowZIndexs[type];
  const height = document.documentElement.clientHeight - (isModelImages ? 212 : 262);

  const handleMouseDown = useCallback(() => {
    if (type === 'images') {
      setTempState({
        imagesWindowZIndexs: {
          images: 105,
          modelImages: 104,
        },
      });
    } else {
      setTempState({
        imagesWindowZIndexs: {
          images: 104,
          modelImages: 105,
        },
      });
    }
  }, [type]);

  const handleCloseModel = useCallback(() => {
    setTempState({
      [type === 'images' ? 'imagesWindowOpened' : 'modelImagesWindowOpened']: null,
    });
  }, [type]);

  useEffect(() => {
    setPosition({ x: 15, y: isModelImages ? 55 : 105 });
  }, [type, isModelImages]);

  if (!position) {
    return null;
  }

  return createPortal(
    <Rnd default={position} scale={1} style={{ zIndex }} enableResizing={false} dragHandleClassName="sub-drag-handle">
      <div
        style={{ height }}
        data-role="images-window"
        onMouseDown={handleMouseDown}
        className="images-window flex flex-col items-stretch w-[360px] bg-white shadow-light overflow-hidden rounded-[2px]"
      >
        {isModelImages ? (
          <header className="relative sub-drag-handle flex flex-shrink-0 items-center justify-center h-11 px-4 cursor-move bg-[#2c2c2c]">
            {isModelImages && <Icon className="icon-home_picture mr-2" fontSize={16} color="#fff" />}
            <div className="flex mr-4 flex-1 overflow-hidden translate-y-px">
              <span className="w-full relative z-[2] whitespace-nowrap overflow-hidden text-ellipsis text-sm font-semibold text-white">
                {label}
              </span>
            </div>
            <button onClick={handleCloseModel}>
              <Icon fontSize={16} className="icon-border_close-1 text-white" />
            </button>
          </header>
        ) : (
          <header className="relative sub-drag-handle flex flex-shrink-0 items-center justify-center h-11 px-4 cursor-move border-b border-[#efefef]">
            <span className="relative z-[2] text-sm font-semibold text-[#2d2d2d]">{label}</span>
            <div className="flex-1" />
            <button onClick={handleCloseModel}>
              <Icon fontSize={16} className="icon-border_close-1 text-[#222]" />
            </button>
          </header>
        )}
        {props.children}
      </div>
    </Rnd>,
    document.body,
  );
});
